import Link from "next/link";
import { CheckCircle2 } from "@/components/icons";
import type { Id } from "@convex/_generated/dataModel";
import { Button } from "@/components/ui/button";
import { CancelRequestButton } from "@/components/deal/cancel-request-button";

export function QuoteSubmittedCard({
  leadId,
  leadNumber,
  email,
}: {
  leadId?: Id<"leads">;
  leadNumber: string;
  email: string;
}) {
  const returnTo = encodeURIComponent("/dashboard/orders");

  return (
    <div className="space-y-4 text-center">
      <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-brand-tint">
        <CheckCircle2 className="h-5 w-5 text-brand-strong" />
      </div>
      <div className="space-y-1">
        <h3 className="text-sm font-semibold text-foreground">
          Request sent{leadNumber ? ` (${leadNumber})` : ""}
        </h3>
        <p className="text-xs text-muted-foreground">
          We&apos;ll email your quote to {email || "you"}.
        </p>
      </div>
      <Button variant="primary" asChild className="w-full">
        <Link href={`/setup?returnTo=${returnTo}`}>
          Finish setup to track it
        </Link>
      </Button>
      {leadId ? (
        <CancelRequestButton
          leadId={leadId}
          leadNumber={leadNumber}
          className="w-full"
        />
      ) : null}
    </div>
  );
}
